import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../../helpers/bgSliders";
import "./SignupPage.scss";
import LebaraSignupPageDisplay from "./SignupPage.styled";
import { setLoginData } from "../../../helpers/helpers";
import { Trans, withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { setAgencyData, saveTracker } from "../../../helpers/agencyTracker";
import queryString from "query-string";
import * as localLang from "../../../i18n/i18n";

const API_BASE = "https://vas2.grand-hub.com/api/playIt/lebara-d";
const randomBg = bgSliders.getRandomBg();

function LebaraSignupPage({ t, i18n }) {
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    const newUrl = `${window.location.pathname}?lang=${lng}`;
    window.history.pushState({}, "", newUrl);
  };
  const [activeData, setActiveData] = useState("");
  const [transactionidentify, setTransactionidentify] = useState("");
  const [checkPhone, setCheckPhone] = useState(false);

  const [showverif, setShowverif] = useState(false);
  const [showSms, setShowSMS] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [errorMesg, setErrorMesg] = useState(false);
  const [verfiErrorMesg, setVerfiErrorMesg] = useState(false);
  const [errorresverify, seterrorresverify] = useState("");

  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const [showLoading, setshowLoading] = useState(false);

  const history = useHistory();
  const [alert, setAlert] = useState(false);

  useEffect(() => {
    const params = queryString.parse(window.location.search);
    if (params.lang) {
      localStorage.setItem("i18nextLng", params.lang);
      if (localStorage.getItem("i18nextLng") != params.lang) {
        localStorage.setItem("i18nextLng", params.lang);
        window.location.reload();
      }
    }

    const urlsearch = window.location.search;
    if (urlsearch !== "") {
      setAgencyData(urlsearch);
    }
  });

  const Subscribe = async (e) => {
    e.preventDefault();
    if (!activeData) {
      setErrorMesgSubscribe("Phone number is required.");
      setErrorMesg(true);
      return;
    }
    const phon_n = activeData.toString();
    const url = `${API_BASE}/subscribe?phone=${phon_n}`;
    setshowLoading(true);
    try {
      const res = await axios.get(url);
      if (res.data.success) {
        localStorage.setItem("phone", phon_n);
        setShowverif(true);
        setErrorMesg(false);
      } else {
        setErrorMesgSubscribe(res.data.message || "Please enter a valid Lebara number.");
        setErrorMesg(true);
      }
    } catch (error) {
      setErrorMesgSubscribe(error.response.data.message || error.message || "Request failed.");
      setErrorMesg(true);
    } finally {
      setshowLoading(false);
    }
  };

  const verify = async (e) => {
    e.preventDefault();
    if (!verifyCode) {
      seterrorresverify(t("Enter_verifycode"));
      setVerfiErrorMesg(true);
      return;
    }

    const phon_n = activeData;
    setshowLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/verify?phone=${phon_n}&otp=${verifyCode}`);
      if (res.data.success === true) {
        setVerfiErrorMesg(false);
        history.push("/thankyouksa");
      } else {
        seterrorresverify(res.data.msg || res.data.message || t("register.VERIFY_ERROR"));
        setVerfiErrorMesg(true);
      }
    } catch (error) {
      seterrorresverify(
        (error.response && error.response.data && (error.response.data.msg || error.response.data.message)) ||
          error.message ||
          t("register.VERIFY_ERROR")
      );
      setVerfiErrorMesg(true);
    } finally {
      setshowLoading(false);
    }
  };

  return (
    <LebaraSignupPageDisplay className="" bgImg={randomBg}>
      {alert && (
        <FloatingAlert type={"danger"}>
          In order to signup please turn your mobile data.
        </FloatingAlert>
      )}

      {errorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMesgSubscribe}</Trans>
        </FloatingAlert>
      ) : null}

      {verfiErrorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorresverify}</Trans>
        </FloatingAlert>
      ) : null}

      <div className="operatorSignup">
        <div className="formsLayout formsLayoutjawal">
          <div className="header header_gamezone d-flex justify-content-between align-items-center">
            <Link to="/">
              <div className="logo logo gamezoneLogo" />
            </Link>
            <div className="language-switcher">
              <button
                onClick={() => changeLanguage("en")}
                className={i18n.language === "en" ? "active" : ""}
              >
                EN
              </button>
              <button
                onClick={() => changeLanguage("ar")}
                className={i18n.language === "ar" ? "active" : ""}
              >
                AR
              </button>
            </div>
          </div>

          {!showverif ? (
            <div className="links-Section links-Sectionjawwalgamezorid">
              <div className="play"></div>
              <p>{t("subscribe_msg")} </p>
              <p className="my-2">{t("subscribe_msg2")} </p>

              <form name="formsubmit" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="text"
                  className="input gamezoneInput gamezonekeyph"
                  value="+966"
                  disabled={true}
                />
                <input
                  type="text"
                  className="input gamezoneInput gamezonenumph"
                  placeholder="XX XXX XX XX"
                  name="phone_number"
                  disabled={checkPhone == true}
                  onChange={(e) =>
                    setActiveData(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
                <br />
                <br />
                <br />
                <button
                  id="signupbut"
                  className="btn"
                  type="submit"
                  onClick={(e) => Subscribe(e)}
                >
                  {t("Subscribe")}
                </button>
              </form>

              <div className="row text-center">
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>98%</span>
                    <img
                      src="/assets/images/subscribegamezriod/like.png"
                      alt="img"
                      className="iconsimg"
                    />
                    <p>
                      <Trans>evaluation</Trans>
                    </p>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>1000+</span>
                    <img
                      src="/assets/images/subscribegamezriod/Repeat.png"
                      alt="img"
                      className="iconsimg"
                    />
                    <p>
                      <Trans>game</Trans>
                    </p>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>500k+</span>
                    <img
                      src="/assets/images/subscribegamezriod/group.png"
                      alt="img"
                      className="iconsimg"
                    />
                    <p>
                      <Trans>user</Trans>
                    </p>
                  </div>
                </div>
              </div>

              <div className="footer jawwalgamezoridFooter zainiqFooter">
                {!showverif ? "" : null}
                <div className="ncellTos jawwalgamezoridncellTos">
                  <p style={{ lineHeight: "1.2", margin: "0 0 5px 0" }}>
                    <Trans>lebara_operator</Trans>
                  </p>
                </div>
              </div>
            </div>
          ) : null}
          {showverif ? (
            <div className="links-Section links-Sectionjawwalgamezorid">
              <div className="play"></div>
              {showSms ? <p><Trans>Click to Subscribe</Trans></p> : <p><Trans>verifycodeJawwalGameszorid</Trans></p>}
              {showSms ? null : (
                <input
                  type="text"
                  className="input"
                  value={verifyCode}
                  placeholder={t("Enter_verifycode")}
                  onChange={(e) => setVerifyCode(e.target.value.replace(/[^0-9]/g, ""))}
                />
              )}
              <br></br>
              <button
                className="btn"
                disabled={verifyCode ? "" : "disabled"}
                onClick={(e) => {
                  verify(e);
                }}
              >
                {showSms ? t("Subscribe") : t("Subscribe")}
              </button>

              <div className="row text-center">
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>98%</span>
                    <img src="/assets/images/subscribegamezriod/like.png" alt="img" className="iconsimg" />
                    <p>
                      <Trans>evaluation</Trans>
                    </p>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>1000+</span>
                    <img src="/assets/images/subscribegamezriod/Repeat.png" alt="img" className="iconsimg" />
                    <p>
                      <Trans>game</Trans>
                    </p>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>500k+</span>
                    <img src="/assets/images/subscribegamezriod/group.png" alt="img" className="iconsimg" />
                    <p>
                      <Trans>user</Trans>
                    </p>
                  </div>
                </div>
              </div>

              <div className="footer jawwalgamezoridFooter zainiqFooter">
                {!showverif ? "" : null}
                <div className="ncellTos jawwalgamezoridncellTos">
                  <p style={{ lineHeight: "1.2", margin: "0 0 5px 0" }}>
                    <Trans>lebara_operator</Trans>
                  </p>
                </div>
              </div>
            </div>
          ) : null}

          {showLoading ? (
            <div className="load">
              <div className="spinerC">
                <div className="spinner"></div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </LebaraSignupPageDisplay>
  );
}
export default withTranslation()(LebaraSignupPage);
